export interface IAbsolutePosition {
    y: number;
    x: number;
}

export function getAbsolutePosition(element: HTMLElement): IAbsolutePosition {
    const position: IAbsolutePosition = {
        x: 0,
        y: 0
    };

    do {
        position.x += element?.offsetLeft || 0;
        position.y += element?.offsetTop || 0;
        element = element?.offsetParent as HTMLElement;
    } while (element);

    return position;
}
